module.exports = __webpack_public_path__ + "static/media/brazil_covid_art_crafts_getty_tablet.6fa336fe.jpg";